import { levelCap } from "./homeKind";
import { isPersonalLevel, reaches, } from "./levels";
import { isResourcePath } from "./resources";
import { isRoleName, ROLES } from "./roles";
export function grantProblems(grant, kind) {
    const problems = [];
    const limit = levelCap(kind);
    const { role } = grant;
    if (role !== null && !isRoleName(role)) {
        problems.push({ code: "unknown_role", role });
    }
    else if (role !== null) {
        const levels = Object.values(ROLES[role].levels);
        if (levels.some((level) => level && !reaches(limit, level))) {
            problems.push({ code: "role_above_limit", role, limit });
        }
    }
    const seen = new Set();
    for (const { resource, level } of grant.personalLevels) {
        if (seen.has(resource)) {
            problems.push({ code: "repeated_resource", resource });
        }
        seen.add(resource);
        if (!isResourcePath(resource)) {
            problems.push({ code: "unknown_resource", resource });
        }
        else if (!isPersonalLevel(level)) {
            problems.push({ code: "unknown_level", resource, level });
        }
        else if (level !== "none" && !reaches(limit, level)) {
            problems.push({ code: "level_above_limit", resource, level, limit });
        }
    }
    return problems;
}
